import {
  useEffect,
  useState,
} from "react";

import {
  Button,
  Col,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";

import {
  getLaitteet,
  createLaite,
  updateLaite,
  deleteLaite,
  getHuollot,
  createHuolto,
  deleteHuolto,
} from "../../api/api";

const EMPTY_DEVICE = {
  id: null,
  laitenimi: "",
  merkki_malli: "",
  hankintapaiva: "",
  leasing: false,
  leasing_paattymispaiva: "",
  kalibroitava: false,
  kalibrointipaiva: "",
  kalibroinnin_uusintapaiva: "",
  vastuuhenkilo_id: null,
  varastossa: false,
};

const EMPTY_MAINTENANCE = {
  paivamaara: "",
  selite: "",
};

export default function DeviceManager({
  userId,
  users = [],
  showToast,
  onCountChange,

}) {
  const [
    laitteet,
    setLaitteet,
  ] = useState([]);

  const [
    loading,
    setLoading,
  ] = useState(false);

  const [
    editingDevice,
    setEditingDevice,
  ] = useState(null);

  const [
    saving,
    setSaving,
  ] = useState(false);

  const [
    maintenanceRows,
    setMaintenanceRows,
  ] = useState([]);

  const [
    maintenanceLoading,
    setMaintenanceLoading,
  ] = useState(false);

  const [
    newMaintenance,
    setNewMaintenance,
  ] = useState(
    EMPTY_MAINTENANCE
  );

  const [
    savingMaintenance,
    setSavingMaintenance,
  ] = useState(false);

  const loadLaitteet =
    async () => {
      if (!userId) return;

      try {
        setLoading(true);

        const data =
          await getLaitteet(
            userId
          );

        setLaitteet(
          Array.isArray(data)
            ? data
            : []
        );
      } catch (error) {
        console.error(
          "❌ Laitteiden lataus epäonnistui:",
          error
        );

        showToast?.(
          "❌ Laitteiden lataus epäonnistui",
          "danger"
        );
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
    loadLaitteet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const handleAdd = () => {
    setEditingDevice({
      ...EMPTY_DEVICE,
      vastuuhenkilo_id:
        userId,
      varastossa: false,
    });

    setMaintenanceRows([]);
    setNewMaintenance(
      EMPTY_MAINTENANCE
    );
  };

  const handleEdit =
    async (device) => {
      setEditingDevice({
        ...EMPTY_DEVICE,
        ...device,

        hankintapaiva:
          device.hankintapaiva
            ? String(
                device.hankintapaiva
              ).slice(0, 10)
            : "",

        leasing_paattymispaiva:
          device.leasing_paattymispaiva
            ? String(
                device.leasing_paattymispaiva
              ).slice(0, 10)
            : "",

        kalibrointipaiva:
          device.kalibrointipaiva
            ? String(
                device.kalibrointipaiva
              ).slice(0, 10)
            : "",

        kalibroinnin_uusintapaiva:
          device.kalibroinnin_uusintapaiva
            ? String(
                device.kalibroinnin_uusintapaiva
              ).slice(0, 10)
            : "",
      });

      setNewMaintenance(
        EMPTY_MAINTENANCE
      );

      try {
        setMaintenanceLoading(
          true
        );

        const data =
          await getHuollot(
            device.id
          );

        setMaintenanceRows(
          Array.isArray(data)
            ? data
            : []
        );
      } catch (error) {
        console.error(
          "❌ Huoltohistorian lataus epäonnistui:",
          error
        );

        setMaintenanceRows([]);
      } finally {
        setMaintenanceLoading(
          false
        );
      }
    };

  const changeDevice = (
    field,
    value
  ) => {
    setEditingDevice(
      (previous) => ({
        ...previous,
        [field]: value,
      })
    );
  };

  const handleSave =
    async () => {
      if (
        !editingDevice?.laitenimi?.trim()
      ) {
        showToast?.(
          "Laitteen nimi vaaditaan",
          "danger"
        );

        return;
      }

      try {
        setSaving(true);

        const payload = {
          laitenimi:
            editingDevice.laitenimi.trim(),

          merkki_malli:
            editingDevice.merkki_malli ||
            "",

          hankintapaiva:
            editingDevice.hankintapaiva ||
            null,

          leasing:
            Boolean(
              editingDevice.leasing
            ),

          leasing_paattymispaiva:
            editingDevice.leasing
              ? editingDevice.leasing_paattymispaiva ||
                null
              : null,

          kalibroitava:
            Boolean(
              editingDevice.kalibroitava
            ),

          kalibrointipaiva:
            editingDevice.kalibroitava
              ? editingDevice.kalibrointipaiva ||
                null
              : null,

          kalibroinnin_uusintapaiva:
            editingDevice.kalibroitava
              ? editingDevice.kalibroinnin_uusintapaiva ||
                null
              : null,

          vastuuhenkilo_id:
            editingDevice.varastossa
              ? null
              : editingDevice.vastuuhenkilo_id,

          varastossa:
            Boolean(
              editingDevice.varastossa
            ),
        };

        if (
          editingDevice.id
        ) {
          await updateLaite(
            editingDevice.id,
            payload
          );
        } else {
          await createLaite(
            userId,
            payload
          );
        }

        await loadLaitteet();

        showToast?.(
          editingDevice.id
            ? "✅ Laitteen tiedot päivitetty"
            : "✅ Laite lisätty",
          "success"
        );
      } catch (error) {
        console.error(
          "❌ Laitteen tallennus epäonnistui:",
          error
        );

        showToast?.(
          "❌ Laitteen tallennus epäonnistui",
          "danger"
        );
      } finally {
        setSaving(false);
      }
    };

  const handleDelete =
    async (device) => {
      if (
        !window.confirm(
          `Haluatko varmasti poistaa laitteen "${device.laitenimi}"?`
        )
      ) {
        return;
      }

      try {
        await deleteLaite(
          device.id
        );

        setLaitteet(
          (previous) =>
            previous.filter(
              (item) =>
                item.id !==
                device.id
            )
        );

        if (
          editingDevice?.id ===
          device.id
        ) {
          setEditingDevice(
            null
          );

          setMaintenanceRows(
            []
          );
        }

        showToast?.(
          "✅ Laite poistettu",
          "success"
        );
      } catch (error) {
        console.error(
          "❌ Laitteen poisto epäonnistui:",
          error
        );

        showToast?.(
          "❌ Laitteen poisto epäonnistui",
          "danger"
        );
      }
    };

  const handleOwnerChange = (
    value
  ) => {
    if (value === "varasto") {
      setEditingDevice(
        (previous) => ({
          ...previous,
          vastuuhenkilo_id:
            null,
          varastossa: true,
        })
      );

      return;
    }

    setEditingDevice(
      (previous) => ({
        ...previous,

        vastuuhenkilo_id:
          value
            ? Number(value)
            : null,

        varastossa: false,
      })
    );
  };

  const addMaintenance =
    async () => {
      if (
        !editingDevice?.id
      ) {
        showToast?.(
          "Tallenna laite ensin ennen huoltohistorian lisäämistä.",
          "warning"
        );

        return;
      }

      if (
        !newMaintenance.paivamaara ||
        !newMaintenance.selite?.trim()
      ) {
        showToast?.(
          "Huollon päivämäärä ja selite vaaditaan.",
          "danger"
        );

        return;
      }

      try {
        setSavingMaintenance(
          true
        );

        const created =
          await createHuolto(
            editingDevice.id,
            {
              paivamaara:
                newMaintenance.paivamaara,

              selite:
                newMaintenance.selite.trim(),
            }
          );

        setMaintenanceRows(
          (previous) => [
            created,
            ...previous,
          ]
        );

        setNewMaintenance(
          EMPTY_MAINTENANCE
        );

        showToast?.(
          "✅ Huolto lisätty",
          "success"
        );
      } catch (error) {
        console.error(
          "❌ Huollon lisäys epäonnistui:",
          error
        );

        showToast?.(
          "❌ Huollon lisäys epäonnistui",
          "danger"
        );
      } finally {
        setSavingMaintenance(
          false
        );
      }
    };

  const deleteMaintenance =
    async (id) => {
      if (
        !window.confirm(
          "Haluatko varmasti poistaa tämän huoltohistorian rivin?"
        )
      ) {
        return;
      }

      try {
        await deleteHuolto(id);

        setMaintenanceRows(
          (previous) =>
            previous.filter(
              (item) =>
                item.id !== id
            )
        );

        showToast?.(
          "✅ Huolto poistettu",
          "success"
        );
      } catch (error) {
        console.error(
          "❌ Huollon poisto epäonnistui:",
          error
        );
      }
    };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5
            className="mb-1"
            style={{
              color: "#264d26",
            }}
          >
            Laitehallinta
          </h5>

          <div className="text-muted small">
            Mittaus- ja työvälineet.
          </div>
        </div>

        <Button
          type="button"
          size="sm"
          onClick={handleAdd}
          style={{
            backgroundColor:
              "#04aa00",
            borderColor:
              "#04aa00",
          }}
        >
          + Lisää laite
        </Button>
      </div>

      {loading ? (
        <div className="text-center py-4">
          <Spinner
            animation="border"
            size="sm"
          />
        </div>
      ) : (
        <div className="d-flex flex-column gap-3">
  {laitteet.map((device, index) => {
    const isEditing =
      editingDevice?.id === device.id;

    return (
      <div
        key={device.id || `device-${index}`}
        style={{
          border: "1px solid #e3e9e3",
          borderLeft: "5px solid #04aa00",
          borderRadius: "12px",
          backgroundColor: "#ffffff",
          boxShadow: "0 3px 10px rgba(0,0,0,0.06)",
          overflow: "hidden",
        }}
      >
        {/* HEADER */}
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            padding: "12px 16px",
            backgroundColor: "#f7fbf7",
            borderBottom: "1px solid #e7ece7",
          }}
        >
          <div className="d-flex align-items-center gap-3">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                backgroundColor: "#04aa00",
                color: "#ffffff",
                fontWeight: "700",
                fontSize: "13px",
                flexShrink: 0,
              }}
            >
              {index + 1}
            </div>

            <div>
              <div
                className="fw-semibold"
                style={{
                  color: "#315b31",
                }}
              >
                {device.laitenimi || "Nimetön laite"}
              </div>

              <div
                className="text-muted"
                style={{
                  fontSize: "12px",
                }}
              >
                {device.merkki_malli || "Merkkiä / mallia ei määritetty"}
              </div>
            </div>
          </div>

          <div className="d-flex gap-2">
            <Button
              type="button"
              size="sm"
              variant="outline-secondary"
              style={
                isEditing
                  ? {
                      backgroundColor: "#04aa00",
                      borderColor: "#04aa00",
                      color: "#ffffff",
                    }
                  : {}
              }
              onClick={() => {
                if (isEditing) {
                  setEditingDevice(null);
                  setMaintenanceRows([]);
                } else {
                  handleEdit(device);
                }
              }}
            >
              {isEditing ? "Valmis" : "Muokkaa"}
            </Button>

            <Button
              type="button"
              size="sm"
              variant="outline-danger"
              onClick={() => handleDelete(device)}
            >
              Poista
            </Button>
          </div>
        </div>

        {/* READ-ONLY ROWS */}
        {!isEditing && (
          <div style={{ padding: "16px" }}>
            <Row className="g-3">
              <Col md={4}>
                <div
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Laitteen nimi
                </div>

                <div>
                  {device.laitenimi || "–"}
                </div>
              </Col>

              <Col md={4}>
                <div
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Merkki ja malli
                </div>

                <div>
                  {device.merkki_malli || "–"}
                </div>
              </Col>

              <Col md={4}>
                <div
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Hankintapäivä
                </div>

                <div>
                  {device.hankintapaiva
                    ? String(device.hankintapaiva).slice(0, 10)
                    : "–"}
                </div>
              </Col>

              <Col md={4}>
                <div
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Leasing
                </div>

                <div>
                  {device.leasing ? "Kyllä" : "Ei"}
                </div>
              </Col>

              {device.leasing && (
                <Col md={4}>
                  <div
                    className="text-muted fw-semibold"
                    style={{ fontSize: "12px" }}
                  >
                    Leasing päättyy
                  </div>

                  <div>
                    {device.leasing_paattymispaiva
                      ? String(
                          device.leasing_paattymispaiva
                        ).slice(0, 10)
                      : "–"}
                  </div>
                </Col>
              )}

              <Col md={4}>
                <div
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Kalibroitava
                </div>

                <div>
                  {device.kalibroitava ? "Kyllä" : "Ei"}
                </div>
              </Col>

              {device.kalibroitava && (
                <>
                  <Col md={4}>
                    <div
                      className="text-muted fw-semibold"
                      style={{ fontSize: "12px" }}
                    >
                      Kalibrointipäivä
                    </div>

                    <div>
                      {device.kalibrointipaiva
                        ? String(device.kalibrointipaiva).slice(0, 10)
                        : "–"}
                    </div>
                  </Col>

                  <Col md={4}>
                    <div
                      className="text-muted fw-semibold"
                      style={{ fontSize: "12px" }}
                    >
                      Seuraava kalibrointi
                    </div>

                    <div>
                      {device.kalibroinnin_uusintapaiva
                        ? String(
                            device.kalibroinnin_uusintapaiva
                          ).slice(0, 10)
                        : "–"}
                    </div>
                  </Col>
                </>
              )}

              <Col md={4}>
                <div
                  className="text-muted fw-semibold"
                  style={{ fontSize: "12px" }}
                >
                  Vastuuhenkilö / sijainti
                </div>

                <div>
                  {device.varastossa
                    ? "Varasto"
                    : users.find(
                        (user) =>
                          Number(user.id) ===
                          Number(device.vastuuhenkilo_id)
                      )?.nimi || "–"}
                </div>
              </Col>
            </Row>
          </div>
        )}

        {/* EDIT MODE */}
        {isEditing && (
          <div style={{ padding: "16px" }}>
            <Row className="g-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold small">
                    Laitteen nimi
                  </Form.Label>

                  <Form.Control
                    value={editingDevice.laitenimi || ""}
                    onChange={(e) =>
                      changeDevice(
                        "laitenimi",
                        e.target.value
                      )
                    }
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group>
                  <Form.Label className="fw-semibold small">
                    Merkki ja malli
                  </Form.Label>

                  <Form.Control
                    value={editingDevice.merkki_malli || ""}
                    onChange={(e) =>
                      changeDevice(
                        "merkki_malli",
                        e.target.value
                      )
                    }
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold small">
                    Hankintapäivä
                  </Form.Label>

                  <Form.Control
                    type="date"
                    value={editingDevice.hankintapaiva || ""}
                    onChange={(e) =>
                      changeDevice(
                        "hankintapaiva",
                        e.target.value
                      )
                    }
                    style={{ borderRadius: "8px" }}
                  />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group>
                  <Form.Label className="fw-semibold small">
                    Vastuuhenkilö / sijainti
                  </Form.Label>

                  <Form.Select
                    value={
                      editingDevice.varastossa
                        ? "varasto"
                        : editingDevice.vastuuhenkilo_id || ""
                    }
                    onChange={(e) =>
                      handleOwnerChange(e.target.value)
                    }
                    style={{ borderRadius: "8px" }}
                  >
                    <option value="">
                      Valitse
                    </option>

                    <option value="varasto">
                      Varasto
                    </option>

                    {users.map((user) => (
                      <option
                        key={user.id}
                        value={user.id}
                      >
                        {user.nimi || user.sahkoposti}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col
                md={4}
                className="d-flex align-items-end"
              >
                <Form.Check
                  type="switch"
                  label="Leasing"
                  checked={Boolean(editingDevice.leasing)}
                  onChange={(e) =>
                    changeDevice(
                      "leasing",
                      e.target.checked
                    )
                  }
                />
              </Col>

              {editingDevice.leasing && (
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="fw-semibold small">
                      Leasing päättyy
                    </Form.Label>

                    <Form.Control
                      type="date"
                      value={
                        editingDevice.leasing_paattymispaiva || ""
                      }
                      onChange={(e) =>
                        changeDevice(
                          "leasing_paattymispaiva",
                          e.target.value
                        )
                      }
                      style={{ borderRadius: "8px" }}
                    />
                  </Form.Group>
                </Col>
              )}

              <Col
                md={4}
                className="d-flex align-items-end"
              >
                <Form.Check
                  type="switch"
                  label="Kalibroitava"
                  checked={Boolean(editingDevice.kalibroitava)}
                  onChange={(e) =>
                    changeDevice(
                      "kalibroitava",
                      e.target.checked
                    )
                  }
                />
              </Col>

              {editingDevice.kalibroitava && (
                <>
                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold small">
                        Kalibrointipäivä
                      </Form.Label>

                      <Form.Control
                        type="date"
                        value={
                          editingDevice.kalibrointipaiva || ""
                        }
                        onChange={(e) =>
                          changeDevice(
                            "kalibrointipaiva",
                            e.target.value
                          )
                        }
                        style={{ borderRadius: "8px" }}
                      />
                    </Form.Group>
                  </Col>

                  <Col md={4}>
                    <Form.Group>
                      <Form.Label className="fw-semibold small">
                        Seuraava kalibrointi
                      </Form.Label>

                      <Form.Control
                        type="date"
                        value={
                          editingDevice.kalibroinnin_uusintapaiva || ""
                        }
                        onChange={(e) =>
                          changeDevice(
                            "kalibroinnin_uusintapaiva",
                            e.target.value
                          )
                        }
                        style={{ borderRadius: "8px" }}
                      />
                    </Form.Group>
                  </Col>
                </>
              )}
            </Row>

            <div className="d-flex gap-2 mt-4">
              <Button
                type="button"
                disabled={saving}
                onClick={handleSave}
                style={{
                  backgroundColor: "#04aa00",
                  borderColor: "#04aa00",
                  borderRadius: "8px",
                }}
              >
                {saving
                  ? "Tallennetaan..."
                  : "Tallenna laite"}
              </Button>
            </div>

            {/* HUOLTOHISTORIA */}
            {editingDevice.id && (
              <div
                className="mt-4 pt-4"
                style={{
                  borderTop: "1px solid #e7ece7",
                }}
              >
                <div
                  className="fw-semibold mb-3"
                  style={{ color: "#315b31" }}
                >
                  Huoltohistoria
                </div>

                <Row className="g-2 mb-3">
                  <Col md={3}>
                    <Form.Control
                      type="date"
                      value={newMaintenance.paivamaara}
                      onChange={(e) =>
                        setNewMaintenance((prev) => ({
                          ...prev,
                          paivamaara: e.target.value,
                        }))
                      }
                    />
                  </Col>

                  <Col md={7}>
                    <Form.Control
                      value={newMaintenance.selite}
                      placeholder="Huollon kuvaus"
                      onChange={(e) =>
                        setNewMaintenance((prev) => ({
                          ...prev,
                          selite: e.target.value,
                        }))
                      }
                    />
                  </Col>

                  <Col md={2}>
                    <Button
                      type="button"
                      disabled={savingMaintenance}
                      onClick={addMaintenance}
                      style={{
                        width: "100%",
                        backgroundColor: "#04aa00",
                        borderColor: "#04aa00",
                      }}
                    >
                      Lisää
                    </Button>
                  </Col>
                </Row>

                {maintenanceLoading ? (
                  <Spinner
                    animation="border"
                    size="sm"
                  />
                ) : maintenanceRows.length === 0 ? (
                  <div className="text-muted small">
                    Ei huoltohistoriaa.
                  </div>
                ) : (
                  maintenanceRows.map((row) => (
                    <div
                      key={row.id}
                      className="d-flex justify-content-between align-items-center py-2"
                      style={{
                        borderBottom: "1px solid #eeeeee",
                      }}
                    >
                      <div>
                        <div className="fw-semibold">
                          {row.paivamaara
                            ? String(row.paivamaara).slice(0, 10)
                            : "–"}
                        </div>

                        <div>{row.selite}</div>
                      </div>

                      <Button
                        type="button"
                        size="sm"
                        variant="outline-danger"
                        onClick={() =>
                          deleteMaintenance(row.id)
                        }
                      >
                        Poista
                      </Button>
                    </div>
                  ))
                )}
              </div>
            )}
          </div>
        )}
      </div>
    );
  })}
</div>
      )}
    </>
  );
}